<app-viz-container [size]="size" [title]="title">
    <div [style.width.%]='100' [style.height.%]='100' [id]="id+'-plot'"></div>
</app-viz-container>